import { useState } from 'react'

import { Metadata } from '@redwoodjs/web'

import { PageHeaderLayout } from 'src/components/Core/PageHeaderLayout'
import { RefreshButton } from 'src/components/Core/RefreshButton'

import { ActivityAnalyticsSectionTabs } from '../CallAnalyticsPage/components/ActivityAnalyticsSectionTabs'
import { FiltersSlotProvider } from '../CallAnalyticsPage/components/FiltersPortal'

import EmailAnalyticsTab from './EmailAnalyticsTab'

const EmailAnalyticsPage = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const [lastUpdatedAt, setLastUpdatedAt] = useState<Date | null>(null)
  const [filtersSlot, setFiltersSlot] = useState<HTMLElement | null>(null)

  const handleRefresh = () => {
    setRefreshKey((k) => k + 1)
    setLastUpdatedAt(new Date())
  }

  return (
    <PageHeaderLayout
      title="Email Analytics"
      tabs={<ActivityAnalyticsSectionTabs section="email" />}
      toolbar={
        <>
          <div
            ref={setFiltersSlot}
            data-testid="email-analytics-filters-slot"
            className="flex flex-wrap items-center gap-1"
          />
          <RefreshButton
            onRefresh={handleRefresh}
            lastUpdatedAt={lastUpdatedAt}
          />
        </>
      }
    >
      <Metadata title="Email Analytics" description="Email Analytics page" />
      <FiltersSlotProvider value={filtersSlot}>
        <EmailAnalyticsTab refreshKey={refreshKey} />
      </FiltersSlotProvider>
    </PageHeaderLayout>
  )
}

export default EmailAnalyticsPage
